// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ybeliymmbvannguhbesq.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InliZWxpeW1tYnZhbm5ndWhiZXNxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQ3MTg3MDAsImV4cCI6MjA2MDI5NDcwMH0.0ETcSJHFR8Z-KydyfbufmHz5JXXrIG7L1WG6lhMvmAg";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);